type LanguageOption = {
	code: string;
	label: string;
};

export const shouldShowLanguagePreference = (
	showLanguageSettings: boolean,
	supportedLocaleCount: number,
	isDevelopment: boolean,
) => (isDevelopment || showLanguageSettings) && supportedLocaleCount > 1;

export const resolveCurrentLanguageLabel = (
	currentLocale: string,
	availableLanguages: LanguageOption[],
) =>
	availableLanguages.find((language) => language.code === currentLocale)
		?.label ?? currentLocale;
